// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx","908":"component---src-pages-markdown-remark-frontmatter-slug-tsx"}[chunkId] + "-" + {"245":"a3069b93a30e1f742c4d","453":"14281429d8bfd549b436","908":"8d8cfc9034bf3ce83501"}[chunkId] + ".js";
};